<script setup lang="ts">
    const props = defineProps({
            icon: String,
            modelValue: Boolean,
            disabled: Boolean,
            title: String
        })

    const emits = defineEmits([
        'update:modelValue'
    ])

    function toggle() {
        if (!props.disabled){
            emits('update:modelValue', !props.modelValue)
        }
    }

</script>

<template>
    <font-awesome-icon :icon="icon" class="button"
        :class="{
            active: modelValue,
            disabled: disabled
        }"
        tabindex="0"
        :title="title"
        @click="toggle"
        @keypress.enter="toggle" />

</template>

<style scoped>
    .button {
        background-color: #ffffff;
        color: #334155;
        padding: 0.2rem;
        width: 1.1rem;
        height: 1.1rem;
        font-size: 0.75rem;
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid #cbd5e1;
        outline: none;
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.1);
    }

    .button:hover {
        background-color: #f1f5f9;
        border-color: #94a3b8;
    }

    .button:focus-visible {
        outline: 3px solid rgba(77, 140, 97, 0.25);
    }

    .button.active {
        background-color: #dff0e4;
        color: #2f6b43;
        border-color: #8fc39e;
    }

    .button.disabled {
        background-color: #f8fafc;
        color: #cbd5e1;
        cursor: default;
        border-color: #e2e8f0;
        box-shadow: none;
    }

    .button.active.disabled {
        background-color: #eef2f7;
        color: #94a3b8;
    }
</style>

